import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function RegisterLink() {
  const navigate = useNavigate();
  
  return (
    <p className="text-center text-sm text-muted-foreground">
      Already have an account?{" "}
      <Button
        variant="link"
        className="p-0 h-auto"
        onClick={() => navigate("/login")}
      >
        Sign In
      </Button>
    </p>
  );
}